import Link from 'next/link';
import { useRouter } from 'next/router';
import { t } from 'i18next';
// components
import { Avatar, AvatarGroup, Popover, Whisper } from 'rsuite';
import { RsuiteTooltip } from '@commons/components';
import { Conect } from './Conect';
// utils && hooks
import { useUser } from 'utils/hooks';
import { COUNTRY } from 'utils/country';
import stringAvatar from 'utils/avatar-name';
// styles
import styles from './PosCard.module.css';

const PosCard = ({ pos }) => {
    const { query } = useRouter();
    const { userLocaleCountryCode } = useUser({});

    const { name, id, address, availableDrugManufacturers, hasAvailableDrugManufacturers, drugManufacturers } = pos;

    return (
        <Link className={styles['wrapper']} href={`/${query.clientId}/settings/POS/${id}/posDetails`}>
            <div className={styles['description']}>
                <div className={styles['redounded']}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M4.18755 17.5C3.72922 17.5 3.33686 17.3368 3.01047 17.0104C2.68408 16.684 2.52089 16.2917 2.52089 15.8333V9.20833C2.20144 8.91667 1.95491 8.54167 1.7813 8.08333C1.60769 7.625 1.60422 7.125 1.77089 6.58333L2.64589 3.75C2.757 3.38889 2.95491 3.09028 3.23964 2.85417C3.52436 2.61806 3.85422 2.5 4.22922 2.5H15.8126C16.1876 2.5 16.5139 2.61458 16.7917 2.84375C17.0695 3.07292 17.2709 3.375 17.3959 3.75L18.2709 6.58333C18.4376 7.125 18.4341 7.61806 18.2605 8.0625C18.0869 8.50694 17.8403 8.88889 17.5209 9.20833V15.8333C17.5209 16.2917 17.3577 16.684 17.0313 17.0104C16.7049 17.3368 16.3126 17.5 15.8542 17.5H4.18755ZM11.8542 8.33333C12.2292 8.33333 12.5139 8.20486 12.7084 7.94792C12.9028 7.69097 12.9792 7.40278 12.9376 7.08333L12.4792 4.16667H10.8542V7.25C10.8542 7.54167 10.9514 7.79514 11.1459 8.01042C11.3403 8.22569 11.5764 8.33333 11.8542 8.33333ZM8.10422 8.33333C8.42366 8.33333 8.68408 8.22569 8.88547 8.01042C9.08686 7.79514 9.18755 7.54167 9.18755 7.25V4.16667H7.56255L7.10422 7.08333C7.04866 7.41667 7.12158 7.70833 7.32297 7.95833C7.52436 8.20833 7.78478 8.33333 8.10422 8.33333ZM4.39589 8.33333C4.64589 8.33333 4.86464 8.24306 5.05214 8.0625C5.23964 7.88194 5.35422 7.65278 5.39589 7.375L5.85422 4.16667H4.22922L3.39589 6.95833C3.31255 7.23611 3.35769 7.53472 3.5313 7.85417C3.70491 8.17361 3.99311 8.33333 4.39589 8.33333ZM15.6459 8.33333C16.0487 8.33333 16.3403 8.17361 16.5209 7.85417C16.7014 7.53472 16.7431 7.23611 16.6459 6.95833L15.7709 4.16667H14.1876L14.6459 7.375C14.6876 7.65278 14.8021 7.88194 14.9896 8.0625C15.1771 8.24306 15.3959 8.33333 15.6459 8.33333ZM4.18755 15.8333H15.8542V9.95833C15.7848 9.98611 15.7396 10 15.7188 10H15.6459C15.2709 10 14.941 9.9375 14.6563 9.8125C14.3716 9.6875 14.0903 9.48611 13.8126 9.20833C13.5626 9.45833 13.2778 9.65278 12.9584 9.79167C12.6389 9.93056 12.2987 10 11.9376 10C11.5626 10 11.2119 9.93056 10.8855 9.79167C10.5591 9.65278 10.2709 9.45833 10.0209 9.20833C9.78477 9.45833 9.51047 9.65278 9.19797 9.79167C8.88547 9.93056 8.54866 10 8.18755 10C7.78478 10 7.42019 9.93056 7.0938 9.79167C6.76741 9.65278 6.47922 9.45833 6.22922 9.20833C5.93755 9.5 5.64936 9.70486 5.36464 9.82292C5.07991 9.94097 4.757 10 4.39589 10H4.30214C4.26741 10 4.22922 9.98611 4.18755 9.95833V15.8333Z"
                            fill="#1E334A"
                        />
                    </svg>
                </div>

                <div className={styles['data']}>
                    <p className={styles['id']}>ID {id}</p>
                    <p className={styles['name']}>{name}</p>
                    <p className={styles['address']}>{address}</p>
                </div>
            </div>

            <div className={styles['avatars']}>
                {availableDrugManufacturers === 0 && !hasAvailableDrugManufacturers ? (
                    <Conect />
                ) : (
                    <AvatarGroup stack style={{ alignItems: 'center' }}>
                        {drugManufacturers
                            ?.filter((drugManufacturer, i) => i < 4)
                            .map(({ name }, i) => (
                                <RsuiteTooltip placement="bottom" trigger="hover" text={name} key={name}>
                                    <Avatar size="md" className={styles['avatar']} circle key={name} alt={name}>
                                        {stringAvatar(name, false, 0)}
                                    </Avatar>
                                </RsuiteTooltip>
                            ))}
                        {drugManufacturers?.length > 4 && (
                            <Whisper
                                placement="bottom"
                                speaker={
                                    <Popover>
                                        {drugManufacturers
                                            .filter((drugManufacturer, i) => i >= 4)
                                            .map(({ name }, index) => {
                                                return (
                                                    <>
                                                        <div className={styles['container-n-avatars']}>
                                                            <Avatar circle className={styles['avatar']} size="md">
                                                                {stringAvatar(name, false, 0)}
                                                            </Avatar>
                                                            <p className={styles['text-avatar-n-droguerias']}>{name}</p>
                                                        </div>
                                                        <hr className={styles['line-divider']} />
                                                    </>
                                                );
                                            })}
                                    </Popover>
                                }
                            >
                                <Avatar circle size="md" className={styles['avatars-menu']}>
                                    {t('efficientPurchasing.avatares.quantity', {
                                        avatarQuantity: `+ ${drugManufacturers.slice(4).length}`,
                                    }) +
                                        `${
                                            drugManufacturers.slice(4).length > 1
                                                ? userLocaleCountryCode === COUNTRY.AR
                                                    ? 's'
                                                    : 'es'
                                                : ''
                                        }`}
                                </Avatar>
                            </Whisper>
                        )}
                    </AvatarGroup>
                )}
            </div>

            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M10.5 9.99935L7.24998 6.74935C7.0972 6.59657 7.02081 6.40213 7.02081 6.16602C7.02081 5.9299 7.0972 5.73546 7.24998 5.58268C7.40276 5.4299 7.5972 5.35352 7.83331 5.35352C8.06942 5.35352 8.26387 5.4299 8.41665 5.58268L12.25 9.41602C12.3333 9.49935 12.3923 9.58963 12.4271 9.68685C12.4618 9.78407 12.4791 9.88824 12.4791 9.99935C12.4791 10.1105 12.4618 10.2146 12.4271 10.3118C12.3923 10.4091 12.3333 10.4993 12.25 10.5827L8.41665 14.416C8.26387 14.5688 8.06942 14.6452 7.83331 14.6452C7.5972 14.6452 7.40276 14.5688 7.24998 14.416C7.0972 14.2632 7.02081 14.0688 7.02081 13.8327C7.02081 13.5966 7.0972 13.4021 7.24998 13.2494L10.5 9.99935Z"
                        fill="#40435B"
                    />
                </svg>
            </div>
        </Link>
    );
};

export default PosCard;
